import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useWeekPlanPreview } from "../../../../../hooks/annual-planner";
import SvgIcon from "../../../../../parts/SvgIcon";
import LogWeekRow from "../../../calendar/components/LogWeekRow";
import PlanWeekRow from "../../../calendar/components/PlanWeekRow";

const SKELETON_DAY_KEYS = ["d0", "d1", "d2", "d3", "d4", "d5", "d6"];

const WeekPlanPreviewSkeleton = () => (
  <div className="week-plan-preview-skeleton">
    {SKELETON_DAY_KEYS.map((key) => (
      <div key={key} className="week-plan-preview-skeleton-day" />
    ))}
  </div>
);

export const WeekPlanPreview = ({
  selectedWeek,
  athlete,
  athleteId,
  organizationCoach,
  organizationCoachId,
  units,
  trackingItems,
}) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  const [contentType, setContentType] = useState("plan");

  const { rowProps, isLoading, error } = useWeekPlanPreview({
    selectedWeek,
    athlete,
    athleteId,
    organizationCoachId,
    contentType,
    units,
    trackingItems,
  });

  const calendarUrl = `/athlete-portal/calendar/?athlete=${athleteId}&month=${moment(
    selectedWeek
  ).format("YYYY-MM")}&view=month&contentType=${contentType}${
    organizationCoach ? `&organizationCoach=${organizationCoach}` : ""
  }`;

  return (
    <div className="week-plan-preview">
      <div className="week-plan-preview-header">
        <div className="week-plan-preview-header-left">
          <div>
            <h3>{t("annualPlanner.weekPlanPreviewTitle")}</h3>
            <span className="week-notes-panel-subtitle">
              {t("annualPlanner.week")}{" "}
              {moment(selectedWeek).format("MMM D, YYYY")}
            </span>
          </div>

          <div className="week-plan-preview-toggle">
            <button
              type="button"
              className={contentType === "plan" ? "value-active" : ""}
              onClick={() => setContentType("plan")}
            >
              <SvgIcon
                src="/img/new-icons/clipboard-notes.svg"
                useCurrentColor={true}
                classNames="icon-sm"
              />
              {t("calendar.plan")}
            </button>
            <button
              type="button"
              className={contentType === "log" ? "value-active" : ""}
              onClick={() => setContentType("log")}
            >
              <SvgIcon
                src="/img/new-icons/document-text.svg"
                useCurrentColor={true}
                classNames="icon-sm"
              />
              {t("calendar.log")}
            </button>
          </div>
        </div>

        <a
          href={calendarUrl}
          role="button"
          data-button-type="outline"
          className="week-plan-preview-open-link summary-goals-empty-cta"
        >
          <span>{t("annualPlanner.openInCalendar")}</span>
        </a>
      </div>

      <div className="week-plan-preview-body">
        {isLoading && <WeekPlanPreviewSkeleton />}
        {!isLoading && error && (
          <span className="week-notes-panel-error">{error}</span>
        )}
        {!isLoading &&
          !error &&
          rowProps &&
          (contentType === "log" ? (
            <LogWeekRow {...rowProps} />
          ) : (
            <PlanWeekRow {...rowProps} />
          ))}
      </div>
    </div>
  );
};
